import { render, staticRenderFns } from "./TemplateLoader.vue?vue&type=template&id=1108c472&scoped=true&"
import script from "./TemplateLoader.vue?vue&type=script&lang=js&"
export * from "./TemplateLoader.vue?vue&type=script&lang=js&"
import style0 from "./TemplateLoader.vue?vue&type=style&index=0&id=1108c472&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1108c472",
  null
  
)

export default component.exports